import React from "react";

import { isProposedAnswer } from "@app/analytics/utils";

import AcceptedAnswer from "./AcceptedAnswer";
import ProposedAnswer from "./ProposedAnswer";
import type { KeyQuestionAnswerProps } from "./types";

const KeyQuestionAnswer = (props: KeyQuestionAnswerProps) => {
  if (props.status === "user_accept") {
    return <AcceptedAnswer {...props} />;
  }

  if (isProposedAnswer(props.status)) {
    return <ProposedAnswer {...props} />;
  }

  return null;
};

export default KeyQuestionAnswer;
